import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Calculator"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M4.5 1.5H19.5C20.3284 1.5 21 2.17157 21 3V21C21 21.8284 20.3284 22.5 19.5 22.5H4.5C3.67157 22.5 3 21.8284 3 21V3C3 2.17157 3.67157 1.5 4.5 1.5ZM19.5 3V21H4.5V3H19.5ZM17.25 5.25H6.75V7.5H17.25V5.25ZM6.75 9.75H8.25V11.25H6.75V9.75ZM6.75 13.5H8.25V15H6.75V13.5ZM8.25 17.25H6.75V18.75H8.25V17.25ZM17.25 17.25H15.75V18.75H17.25V17.25ZM17.25 13.5H15.75V15H17.25V13.5ZM12.75 17.25H11.25V18.75H12.75V17.25ZM11.25 13.5H12.75V15H11.25V13.5ZM12.75 9.75H11.25V11.25H12.75V9.75ZM15.75 9.75H17.25V11.25H15.75V9.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Calculator.vue"]]);
